<template>
  <mdb-container class="gp-has-header">
    <div v-show="view=='list'">
      <data-table :add-handler="newSet"
                  :clickHandler="openSet"
                  :columns="columns"
                  add-label="New Set"
                  dataSource="/campfireAdmin/cardSetList"
                  pageTitle="Game Card Sets"
                  table-id="card-set"
                  show-add-button/>
    </div>

    <div v-if="view=='edit'" class="text-left">
      <mdb-btn icon="arrow-left" @click="goBack">Back to List</mdb-btn>

      <mdb-card>
        <mdb-card-header>
          <h3>{{ editingSet.title }}</h3>
        </mdb-card-header>
        <mdb-card-body>
          <div v-if="editDetails">
            <mdb-input v-model="workingSet.title" label="Title" placeholder="Title"/>
            <mdb-btn :disabled="!workingSet.title" color="success" icon="save" @click="saveSet">Save</mdb-btn>
            <mdb-btn icon="minus-circle" @click="cancelEdit">Cancel</mdb-btn>
          </div>
          <mdb-btn v-if="!editDetails" icon="pencil" rounded size="sm" @click="prepareEdit"/>
          <mdb-btn v-if="!editDetails" color="danger" icon="trash" rounded size="sm" @click="deleteModal = true"/>

          <data-table v-if="editingSet.id"
                      :add-handler="newCard"
                      :clickHandler="prepareEditCard"
                      :columns="cardColumns"
                      :dataSource="'/campfireAdmin/cardList/' + this.editingSet.id"
                      add-label="New Card"
                      pageTitle="Game Card Sets"
                      table-id="card"
                      show-add-button/>

        </mdb-card-body>
      </mdb-card>

      <mdb-modal v-if="editCard" size="lg" @close="editCard=false">
        <mdb-modal-header :close="true" class="secondary-color">
          <h3>Card Details</h3>
        </mdb-modal-header>
        <mdb-modal-body>
          <mdb-card>
            <mdb-card-body>
              <mdb-input v-model="workingCard.front":rows="2" label="Front" placeholder="Front"
                         type="textarea"/>
              <mdb-input v-model="workingCard.back" :rows="2" label="Back" placeholder="Back"
                         type="textarea"/>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn color="success" icon="save" rounded size="sm" @click="saveCard">Save</mdb-btn>
              <mdb-btn icon="times-circle" rounded size="sm" @click="editCard=false">Cancel</mdb-btn>
              <mdb-btn icon="trash" color="danger" rounded size="sm" @click="deleteCardModal=true">Delete</mdb-btn>
            </mdb-card-footer>
          </mdb-card>

        </mdb-modal-body>
      </mdb-modal>

      <yes-no-modal v-if="deleteModal" additional-text="Set and all related cards will be deleted."
                    @no="deleteModal=false"
                    @yes="deleteSet"/>

      <yes-no-modal v-if="deleteCardModal"
                    @no="deleteCardModal=false"
                    @yes="deleteCard"/>

    </div>

  </mdb-container>
</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow
} from 'mdbvue';

import DataTable from "../common/DataTable";
import api from "../../services/groupsPlaceApi";
import YesNoModal from "../common/YesNoModal";

export default {
  name: 'game-card-set',
  components: {
    mdbContainer, mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbIcon,
    mdbRow,
    mdbCol,
    DataTable,
    YesNoModal
  },
  data() {
    return {
      columns: [
        {label: "ID", field: "id"},
        {label: "Title", field: "title"}
      ],
      cardColumns: [
        {label: "ID", field: "id"},
        {label: "Front", field: "front"},
        {label: "Back", field: "back"}
      ],
      editingSet: null,
      editingCard: null,
      workingSet: null,
      workingCard: null,
      view: "list",
      editDetails: false,
      needsRefresh: false,
      deleteModal: false,
      deleteCardModal: false,
      editCard: false
    }
  },
  methods: {
    openSet(cardSet) {
      this.editingSet = cardSet
      this.view = "edit"
    },
    prepareEdit() {
      this.workingSet = JSON.parse(JSON.stringify(this.editingSet))
      this.editDetails = true
    },
    prepareEditCard(card) {
      this.editingCard = card
      this.workingCard = JSON.parse(JSON.stringify(card))
      this.editCard = true
    },
    newSet() {
      this.editingSet = {title: "New Set"}
      this.workingSet = {id: null, title: ""}
      this.view = "edit"
      this.editDetails = true
    },
    newCard() {
      this.editingCard = null
      this.workingCard = {front: "", back: "", id: null, cardSetId: this.editingSet.id}
      this.editCard = true
    },
    goBack() {
      this.view = "list"
      if (this.needsRefresh) this.$store.dispatch("setDataTableReload", true)
      this.workingSet = null
      this.editingSet = null
      this.editDetails = false
    },
    cancelEdit() {
      if (!this.workingSet.id) {
        this.view = "list"
        this.editingSet = null
      }
      this.workingSet = null
      this.editDetails = false
    },
    saveSet() {
      this.setModal = false
      this.$store.dispatch("setExecuting", true);
      api.post("/campfireAdmin/cardSet/", this.workingSet).then(
        (results) => {
          this.editDetails = false
          this.workingSet = null
          this.editingSet = results.data
          this.needsRefresh = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.setModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveCard() {
      this.editCard = false
      this.$store.dispatch("setExecuting", true);
      api.post("/campfireAdmin/card/", this.workingCard).then(
        (results) => {
          let payload = {tableId: "card", data: results.data}
          if (this.workingCard.id) {
           this.$store.dispatch("updateTableRow", payload)
          }
          else {
            this.$store.dispatch("insertTableRow", payload)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.editCard = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    deleteCard() {
      this.editCard = false
      this.deleteCardModal  = false
      this.$store.dispatch("setExecuting", true);
      api.delete("/campfireAdmin/card/" + this.workingCard.id).then(
        (results) => {
          let payload = {tableId: "card", data: this.editingCard}
          this.$store.dispatch("deleteTableRow", payload)
          this.workingCard = null
          this.editingCard = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.editCard = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    deleteSet() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true);
      api.delete("/campfireAdmin/cardSet/" + this.editingSet.id).then(
        (results) => {
          this.needsRefresh = true
          this.goBack()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

};
</script>
